<router-outlet></router-outlet>
<modal-component #submissionSource
                 (reject)="downloadFile(sourceModalUuid)"
                 (edit)="editFile()"
                 (resubmit)="resubmitFile(editSubmissionSourceModalXmlContent)"
                 (confirmReprocess)="confirmReprocess()"
                 (reprocess)="reprocessFile(sourceModalUuid)"
                 [title]="submissionSourceModalTitle"
                 [data]="{
                  resizeOrClose:'close',
                  okBtnCssClass:'btn btn-primary',
                  spinnerCssClass:'mat-spinner-primary',
                  cancelBtnCssClass:'hml-button-download-file',
                  cancelBtnTitle: ''}">
    <div class="hml-source-text">{{submissionSourceDisplay()}}</div>
</modal-component>
<modal-edit-component #editSubmissionSource
                      [injectProperty]="injectProperty"
                 (resubmit)="confirmResubmit()"
                 (addEditProp)="addEditProp($event)"
                 [title]="submissionSourceModalTitle"
                 [data]="{
                  resizeOrClose:'close',
                  okBtnTitle:'Cancel',
                  okBtnCssClass:'btn btn-primary',
                  resubmitBtnTitle: 'Submit',
                  editable:true}">
    <div class="hml-source-text">{{submissionSourceModalXmlContent}}</div>
</modal-edit-component>
